module.exports = __webpack_public_path__ + "static/media/thisBannerTriengel.100df4a6.jpeg";